module.exports = __webpack_public_path__ + "img/boat.695c855d.png";